export default class Paragraph {
  constructor({ text, condition }) {
    this.component = 'p'
    this.condition = condition
    this.innerText = text
  }
}
